export const DEFAULT_INLINE_INDENT = 20;
